import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const TodaysBirthdayAlert = ({ 
  todaysBirthdays = [],
  onDismiss = () => {},
  onSendWishes = () => {}
}) => {
  const [isDismissed, setIsDismissed] = useState(false);
  const navigate = useNavigate();

  if (todaysBirthdays?.length === 0 || isDismissed) {
    return null;
  }

  const handleDismiss = () => {
    setIsDismissed(true);
    onDismiss();
  };

  const handleSendWishesToAll = () => {
    onSendWishes(todaysBirthdays);
    navigate('/message-templates', { 
      state: { 
        selectedContacts: todaysBirthdays, 
        type: 'birthday' 
      } 
    });
  };

  const handleSendWishesToContact = (contact) => {
    onSendWishes([contact]);
    navigate('/message-templates', { 
      state: { 
        selectedContact: contact, 
        type: 'birthday' 
      } 
    });
  };

  const handleViewContact = (contact) => {
    navigate('/contact-details', { state: { contact } });
  };

  return (
    <div className="bg-gradient-to-r from-primary/10 to-accent/10 border border-primary/20 rounded-lg p-4 lg:p-6 mb-6 animate-slide-up">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-primary rounded-full flex items-center justify-center animate-pulse">
            <Icon name="Gift" size={24} color="white" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-text-primary">
              🎉 Birthday Alert!
            </h2>
            <p className="text-text-secondary">
              {todaysBirthdays?.length} contact{todaysBirthdays?.length > 1 ? 's have' : ' has'} birthday{todaysBirthdays?.length > 1 ? 's' : ''} today
            </p>
          </div>
        </div>
        
        <Button
          variant="ghost"
          size="icon"
          onClick={handleDismiss}
          className="text-text-secondary hover:text-text-primary"
        >
          <Icon name="X" size={20} />
        </Button>
      </div>
      {/* Birthday Contacts */}
      <div className="space-y-3 mb-4">
        {todaysBirthdays?.slice(0, 3)?.map((contact) => (
          <div
            key={contact?.id}
            className="flex items-center space-x-3 p-3 bg-surface rounded-lg border border-border"
          >
            <div className="relative">
              <div className="w-12 h-12 rounded-full overflow-hidden bg-muted">
                {contact?.avatar ? (
                  <Image
                    src={contact?.avatar}
                    alt={contact?.name}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-primary/20">
                    <Icon name="User" size={20} className="text-primary" />
                  </div>
                )}
              </div>
              <div className="absolute -top-1 -right-1 w-6 h-6 bg-accent rounded-full flex items-center justify-center">
                <Icon name="Gift" size={12} color="white" />
              </div>
            </div>

            <div className="flex-1 min-w-0">
              <h3 className="font-medium text-text-primary truncate">
                {contact?.name}
              </h3>
              <p className="text-sm text-text-secondary">
                {contact?.age ? `Turning ${contact?.age} today` : 'Birthday today'}
              </p>
            </div>

            <div className="flex items-center space-x-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleViewContact(contact)}
                iconName="Eye"
                iconPosition="left"
              >
                View
              </Button>
              <Button
                variant="default"
                size="sm"
                onClick={() => handleSendWishesToContact(contact)}
                iconName="Send"
                iconPosition="left"
              >
                Send Wishes
              </Button>
            </div>
          </div>
        ))}

        {todaysBirthdays?.length > 3 && (
          <div className="text-center py-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate('/birthday-calendar')}
              iconName="Plus"
              iconPosition="left"
            >
              View {todaysBirthdays?.length - 3} more
            </Button>
          </div>
        )}
      </div>
      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="default"
          onClick={handleSendWishesToAll}
          iconName="Send"
          iconPosition="left"
          className="flex-1"
        >
          Send Wishes to All ({todaysBirthdays?.length})
        </Button>
        <Button
          variant="outline"
          onClick={() => navigate('/birthday-calendar')}
          iconName="Calendar"
          iconPosition="left"
          className="flex-1"
        >
          View Birthday Calendar
        </Button>
      </div>
    </div>
  );
};

export default TodaysBirthdayAlert;